import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import TaxSimulator from "./components/TaxSimulator";
import PrivacyPolicy from "./components/PrivacyPolicy";
import AboutPage from "./components/AboutPage";
import ContactPage from "./components/ContactPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<TaxSimulator />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
